/* app/js/src/components/common/wizard/wizard-substep.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: none;
}
:host.active {
  display: block;
}
h3 {
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0.1px;
  margin: 0;
  color: #232f3a;
  margin-bottom: 20px;
  white-space: pre-wrap;
}
/*# sourceMappingURL=wizard-substep.component.css.map */
